export default __webpack_public_path__ + "static/media/khann.40f577c5.jpg";